export default function TopLable({ items }) {
    return (
        <div className="top-cards-row">
            {items && items?.length > 0 && items?.map((data, i) => {
                return (
                    <div key={i} className="card dash-cards" style={{ minHeight: "85px" }}>
                        <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between">
                                <h1>{data?.label}:</h1>
                                <h2>{data?.value}</h2>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
